// Module
var code = "<div class=\"bz-score-modal\"> <button type=\"button\" class=\"bz-score-modal-close close\" ng-click=\"dismiss()\"> &times; </button> <bz-score contractor=\"contractor\" omit-quote-cta=\"omitQuoteCta\" on-submit=\"dismiss()\"></bz-score> </div> ";
// Exports
module.exports = code;